import { assertReviewed } from './review.js';
import { excessOver } from './bps.js';
/**
 * ISA subscription room. ONE £20,000 allowance per person per tax year,
 * shared across every ISA type (cash ISA + stocks & shares ISA together) —
 * the engine must aggregate a person's subscriptions before asking for room.
 */
export function isaSubscriptionRoom(rules, subscribedThisYear) {
    assertReviewed(rules);
    if (!Number.isSafeInteger(subscribedThisYear) || subscribedThisYear < 0) {
        throw new RangeError('Subscribed amount must be a non-negative integer of pence');
    }
    return excessOver(rules.isa.annualSubscriptionLimit, subscribedThisYear);
}
function assertNonNegativePence(value, label) {
    if (!Number.isSafeInteger(value) || value < 0) {
        throw new RangeError(`${label} must be a non-negative integer of pence`);
    }
}
/**
 * Lifetime ISA payment room for the year. The LISA has its OWN £4,000 annual
 * limit, and every pound paid in also consumes the shared £20,000 allowance —
 * so the room is the smaller of the two remainders. Payments are only allowed
 * up to the holder's 50th birthday (checked by the caller against
 * `rules.isa.lisaMaxContributionAge`). Returns 0 when the rule set predates
 * the LISA figures.
 */
export function lisaSubscriptionRoom(rules, lisaSubscribedThisYear, totalIsaSubscribedThisYear) {
    assertReviewed(rules);
    assertNonNegativePence(lisaSubscribedThisYear, 'LISA subscribed amount');
    assertNonNegativePence(totalIsaSubscribedThisYear, 'Total ISA subscribed amount');
    const limit = rules.isa.lisaAnnualLimit;
    if (limit === undefined)
        return 0;
    return Math.min(excessOver(limit, lisaSubscribedThisYear), excessOver(rules.isa.annualSubscriptionLimit, totalIsaSubscribedThisYear));
}
/** The 25% government bonus paid on a Lifetime ISA subscription. */
export function lisaBonus(rules, subscription) {
    assertReviewed(rules);
    assertNonNegativePence(subscription, 'LISA subscription');
    const bonusBps = rules.isa.lisaBonusBps ?? 0;
    return Math.trunc((subscription * bonusBps) / 10_000);
}
/**
 * Junior ISA payment room for the year, PER CHILD. The £9,000 JISA limit is
 * separate from (and does not consume) the adult £20,000 allowance. Returns 0
 * when the rule set predates the JISA figure.
 */
export function jisaSubscriptionRoom(rules, subscribedThisYear) {
    assertReviewed(rules);
    assertNonNegativePence(subscribedThisYear, 'JISA subscribed amount');
    const limit = rules.isa.jisaAnnualLimit;
    if (limit === undefined)
        return 0;
    return excessOver(limit, subscribedThisYear);
}
//# sourceMappingURL=isa.js.map